/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { FieldActivitiesFetch } from '../../api/services/NotebookAPI';

export default function FieldActivity({ history }) {
  const token = getToken();
  const [fieldActivities, setFieldActivities] = useState([]);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getFieldActivities() {
      setIsLoad(true);
      try {
        const resultFieldActivities = await FieldActivitiesFetch(token);
        console.log('getFieldActivities | resultFieldActivities: ', resultFieldActivities);
        setIsLoad(false);
        setMessageWarning(resultFieldActivities.message);
        setIsSuccessMessage(resultFieldActivities.isSuccess);
        if (resultFieldActivities.isSuccess) {
          setFieldActivities(resultFieldActivities.fieldActivities);
        }
      } catch (error) {
        console.log('getFieldActivities | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getFieldActivities();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Histórico de Atividades
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          <button
            className="form__button"
            type="button"
            // eslint-disable-next-line no-undef
            onClick={() => navigate('/notebook/field-activity/create', { replace: true })}
          >
            Registrar Atividade
          </button>

          {fieldActivities.map((fieldActivity) => (
            <div
              className="detail__container"
              onClick={() => navigate(`/notebook/field-activity/${fieldActivity.id}`, { replace: true })}
              aria-hidden="true"
            >
              <p className="detail__value">
                {(fieldActivity.activity).toUpperCase()}
              </p>
              <p className="detail__value">
                {calendarUSAMask(fieldActivity.created)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
